import React from "react";
import { SmartphoneIcon, PhoneIcon, MailPlusIcon } from "lucide-react";
import { formatPhoneNumber } from "@/lib/utils";
import { MOVE_STATUSES } from "@/constants";
import { Move } from "@/types";
import Summary from "./components/Summary";
const STATUS_COLORS = {
  initial: "bg-green-500",
  quoted: "bg-yellow-500",
  booked: "bg-blue-500",
  in_progress: "bg-orange-500",
  completed: "bg-green-500",
  lost: "bg-black",
  canceled: "bg-red-500",
  expired: "bg-gray-500",
};

interface HeaderProps {
  move: Move;
}

const Header: React.FC<HeaderProps> = ({ move }) => {
  return (
    <div className="bg-stone-50 border-b border-black px-4 sticky top-28 left-0 z-[1]">
      <div className="flex flex-col lg:flex-row items-center justify-start gap-16">
        <div className="flex items-center gap-6">
          <div className="p-4 flex items-center justify-start gap-4 mb-0">
            <div className="flex flex-col items-start justify-start gap-2">
              <div>
                <p className="text-sm font-normal">MOVE #{move.number}</p>
                <h1 className="max-w-48 w-auto text-2xl font-semibold">
                  {move.customer_name}
                </h1>
              </div>
              <div
                className={`${
                  STATUS_COLORS[move.status as keyof typeof STATUS_COLORS]
                } px-2 py-1 text-white text-sm`}
              >
                {MOVE_STATUSES[move.status as keyof typeof MOVE_STATUSES] ||
                  "-"}
              </div>
            </div>

            <div className="flex flex-col gap-1">
              {move.customer_mobile_phone && (
                <div className="flex space-x-2 items-center">
                  <SmartphoneIcon className="w-4 h-4" />
                  <a
                    className="text-sm link"
                    href={`tel:${move.customer_mobile_phone}`}
                  >
                    {formatPhoneNumber(move.customer_mobile_phone)}
                  </a>
                </div>
              )}
              {move.customer_alternate_phone && (
                <div className="flex space-x-2 items-center">
                  <PhoneIcon className="w-4 h-4" />
                  <a
                    className="text-sm link"
                    href={`tel:${move.customer_alternate_phone}`}
                  >
                    {formatPhoneNumber(move.customer_alternate_phone)}
                  </a>
                </div>
              )}
              {move.customer_email && (
                <div className="flex space-x-2 items-center">
                  <MailPlusIcon className="w-4 h-4" />
                  <a
                    className="text-sm link"
                    href={`mailto:${move.customer_email}`}
                  >
                    {move.customer_email}
                  </a>
                </div>
              )}
            </div>
          </div>
          <div className="flex flex-row items-end justify-start gap-6 py-4"></div>
        </div>
        <div>
          <div className="flex items-center bg-white lg:bg-stone-50">
            <Summary move={move} />
            <div className="flex flex-row items-center gap-0">
              {/* {move.status !== "completed" && (
                <Button
                  type="button"
                  variant="default"
                  className={"rounded-r-none shadow-none"}
                  onClick={() => navigate(`/move/update/${move.id}`)}
                >
                  Edit Move Details
                </Button>
              )} */}
              <div
                data-orientation="vertical"
                role="none"
                className="shrink-0 w-[1px] h-9"
              ></div>
              {/* modal=false is necessary else dropdown is not clickable after the dialog alert on cancel move is closed */}
              {/* <DropdownMenu modal={false}>
                <DropdownMenuTrigger asChild>
                  <Button
                    variant="outline"
                    className={
                      "rounded-l-none bg-yellow-500 hover:bg-yellow-500/90 px-2 py-2 h-9"
                    }
                  >
                    <ChevronDownIcon className="w-4 h-4" />
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent
                  side="bottom"
                  align="end"
                ></DropdownMenuContent>
              </DropdownMenu> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
